import * as ajax from "../../../actions/ajaxCounterActions";
import * as exception from "../../../actions/exceptionActions";

import financieelApi from "../../../api/financieelApi";

import { getStore } from "../../../store/configureStore";

export default class OpbrengstenPageHelper {
	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		this.context.setState({
			financieelOpbrengsten: null,
			modalIsOpen: false,
			opbrengstId: null
		});

		const dossierId = this.context.props.dossierId;
		this.getKostenByDossierId(dossierId);
	}

	loadLayout(financieel) {
		const dossierId = this.context.props.dossierId;

		this.context.props.loadLayout(financieel.naam, financieel.tabTitel, dossierId, financieel.typeDossier);
	}

	loadBeads(beadModels) {
		this.context.props.beadsLoaded(beadModels);
	}

	getKostenByDossierId(dossierId) {
		this.dispatch(ajax.started());
		financieelApi.getKostenByDossierId(dossierId)
			.then(response => {
				this.dispatch(ajax.ended());
				this.setStateAfterUpdate(response.data);
				this.loadBeads(response.data.beadModels);
				this.loadLayout(response.data);
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	isReadyToRender() {
		if (!this.context.state.financieelOpbrengsten) {
			return false;
		}

		if (this.context.props.okiTypes.length < 1) {
			return false;
		}

		return true;
	}

	setStateAfterUpdate(item) {
		this.context.setState({
			financieelOpbrengsten: item
		});
	}

	deleteOpbrengstKostInvestering() {
		this.closeModal();
		const state = this.context.state;
		const id = state.opbrengstId;
		this.dispatch(ajax.started());
		financieelApi.deleteOpbrengstKostInvestering(id)
			.then(response => {
				let opbrengsten = state.financieelOpbrengsten.opbrengstKostInvesteringen;
				let newOpbrengsten = Object.assign({},
					state.financieelOpbrengsten,
					{
						opbrengstKostInvesteringen: opbrengsten.filter(k => k.id !== id)
					});
				this.dispatch(ajax.ended());
				this.setStateAfterUpdate(newOpbrengsten);
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	goToOpbrengstEdit() {
		this.redirector.goTo(`financieel/${this.context.props.dossierId}/opbrengstedit/new`);
	}

	goToOpbrengstEditWijzig(id) {
		this.redirector.goTo(`financieel/${this.context.props.dossierId}/opbrengstedit/${id}`);
	}

	closeModal() {
		this.context.setState({
			modalIsOpen: false
		});
	}

	openModal(id) {
		this.context.setState({
			modalIsOpen: true,
			opbrengstId: id
		});
	}
}